import React from 'react';
import Chip from '../../../Components/Chip';
import ActivityTypeAvatar from '../../../Components/ActivityTypeAvatar';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import { OUTCOME_COLORS } from '../../MassiveMessages/Utils/constants';

export const FILTERS = [
  { keyName: 'opened', operator: 'eq' },
  { keyName: 'sent', operator: 'eq' },
  { keyName: 'tagId' },
  { keyName: 'activityType' },
  { keyName: 'campaignName', operator: 'eq' },
  { keyName: 'branchId' },
];

export const SORTING = [
  { label: 'NAME', value: 'customerName', isDefault: true },
  { label: 'SURNAME', value: 'customerSurname' },
  { label: 'MOBILE_PHONE', value: 'phoneNumber' },
];

//activityType values expected by BE, labels are translated
export const CHANNELS = [
  { label: 'EMAIL', value: 0, activityType: 'EMAIL' },
  { label: 'SMS', value: 1, activityType: 'SMS' },
];

//tags have no fixed color: Chip derives it from the label like the donut does
const getChipProps = (tagName, opened, sent, translate) => {
  if (tagName) return { label: translate(tagName) };
  if (opened)
    return { label: translate('OPENED'), color: OUTCOME_COLORS.POSITIVE };
  return sent
    ? { label: translate('DELIVERED'), color: OUTCOME_COLORS.SENT }
    : { label: translate('NOT_DELIVERED'), color: OUTCOME_COLORS.NEGATIVE };
};

export const CONTACT_COLUMNS = [
  {
    id: 'activityType',
    noCaption: true,
    size: 'auto',
    formatCallback: (value) => <ActivityTypeAvatar activityType={value} />,
  },
  {
    id: 'customerName',
    label: 'NOMINATIVE',
    formatCallback: (value, data) =>
      capitalize(`${value ?? ''} ${data?.customerSurname ?? ''}`.trim()),
  },
  {
    id: 'recipient',
    label: 'RECIPIENT',
    size: 3,
    formatCallback: (value, data) =>
      data?.activityType === 'SMS' ? data?.phoneNumber : data?.email,
  },
  {
    id: 'outcome',
    label: 'OUTCOME',
    size: 2,
    formatCallback: (value, data, translate) => (
      <Chip
        width="fit-content"
        {...getChipProps(data?.tagName, data?.opened, data?.sent, translate)}
      />
    ),
  },
];
